import {
  IndicatorRing,
  IndicatorRingProps
} from "../IndicatorRing/IndicatorRing";

export type OccupancyIndicatorProps = {
  occupiedSpaces: IndicatorRingProps["value"];
  totalSpaces: IndicatorRingProps["total"];
  variant?: IndicatorRingProps["variant"];
  displaySpacesCount?: boolean;
};

export const OccupancyIndicator = ({
  occupiedSpaces,
  totalSpaces,
  variant,
  displaySpacesCount = true
}: OccupancyIndicatorProps) => {
  return (
    <div className="flex items-center gap-2 text-neutral-300 text-xs">
      {displaySpacesCount && occupiedSpaces}
      <IndicatorRing
        value={occupiedSpaces}
        total={totalSpaces}
        variant={variant}
      />
    </div>
  );
};
